import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import "./SurveyCreation.scss";
import Navbar from "../../layout/header/Header";
import ActiveLink from "../../layout/active-link/ActiveLink";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { ReactMultiEmail, isEmail } from "react-multi-email";
import "react-multi-email/dist/style.css";
import { postSurvey } from "../../../api/services/survey-apis";
import { postEmail } from "../../../api/services/email-api";
import {
  getAllAssessments,
  getAssessmentById,
} from "../../../api/services/assessment-apis";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Typeahead } from "react-bootstrap-typeahead";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-typeahead/css/Typeahead.css";
import "react-bootstrap-typeahead/css/Typeahead.bs5.css";
 
const SurveyCreation = () => {
  const [surveyData, setSurveyData] = useState<any>([]);
  const [setId, setSetId] = useState<number>();
  const [showTable, setShowTable] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [sets, setSets] = useState<{ setId: number; setName: string }[]>([]); // Updated type to include setId
  const [filteredSets, setFilteredSets] = useState<
    { setId: number; setName: string }[]
  >([]); // Updated type to include setId
  const [searchTerm, setSearchTerm] = useState(""); // Added state for search term
  const getRowColor = (index: any) => {
    return index % 2 === 1 ? "#D9D9D9" : "white";
  };
  const location = useLocation();
  const data = location.state;
  const navigate = useNavigate();
  const AssessmentDetails = location.state?.AssessmentDetails;
  const options: string[] = ["test"];
  const [selectedList, setSelectedList] = useState<string[]>([]);
  const [descCount, setDescCount] = useState(0);
  const [emails, setEmails] = useState<string[]>([]);
  const [inputs, setInputs] = useState<any>({});
  const [setName, setSetName] = useState("");
  const [surveyId, setSurveyId] = useState<number>();
  const [requestor, setRequestor] = useState(
    AssessmentDetails?.requestor ?? ""
  );
  const descriptionRef  =  useRef<HTMLTextAreaElement>(null);
 
  const TypeaheadDomain: React.FC = () => (
    <Typeahead
      id="typeaheadId"
      onChange={(selected: any) => setSelectedList(selected)}
      options={options}
      placeholder="Select or create domain"
      selected={selectedList}
    />
  );
 
  useEffect(() => {
    // Fetch all assessments
    getAllAssessments()
      .then((response) => {
        // Filter sets to include only those with status "APPROVED"
        const approvedSets = response.data.filter(
          (set: { status: string }) => set.status === "APPROVED"
        ); // Added filtering logic
        setSets(approvedSets);
      })
      .catch((error) => {
        console.error("Error fetching assessments:", error);
      });
  }, []);
 
  const handleSetNameChange = (selected: any) => {
    if (selected.length > 0) {
      const selectedSetName = selected[0].setName;
      setSearchTerm(selectedSetName); // Update searchTerm
      setSetName(selectedSetName); // Update setName
      setInputs((prevInputs: any) => ({
        ...prevInputs,
        setName: selectedSetName, // Update setName in inputs
      }));
    } else {
      setSearchTerm("");
      setSetName(""); // Clear setName
      setInputs((prevInputs: any) => ({
        ...prevInputs,
        setName: "", // Clear setName in inputs
      }));
    }
  };
 
  const handleSearch = () => {
    // Added handleSearch function
    const selectedSet = sets.find((set) =>
      set.setName.toLowerCase().includes(searchTerm.toLowerCase())
    );
 
    if (selectedSet) {
      getAssessmentById(selectedSet.setName)
        .then((data: any) => {
          setTableData(data.data.sectionList);
          setTableData(data.data.sectionList);
          setSetId(data.data.setID);
          setShowTable(true);
        })
        .catch((error) => {
          console.error("Error fetching assessment by ID:", error);
          toast.error("Error fetching assessment by ID");
        });
    } else {
      toast.error("No matching assessment found");
    }
  };
 
  const handleChange = (event: any) => {
    const name = event.target.name;
    const value = event.target.value;

    if (name === "surveyDscr") {
        setDescCount(value.length);
        if(descriptionRef.current) {
          descriptionRef.current.scrollTop = 0;
      }
    }
    if (name === "setName") {
      setSetName(value);
    }
    setInputs((values: any) => ({
      ...values,
      [name]: value,
      emails: emails,
      requestor: requestor,
      setName: setName,
    }));
  };
 
  const sendEmail = async (surveyId: number, email: string) => {
    // Calculate the deadline date (30 days from the current date)
    const currentDate = new Date();
    const deadlineDate = new Date(currentDate);
    deadlineDate.setDate(currentDate.getDate() + 30);
 
    // Format the deadline date as a string in the format YYYY-MM-DD

    const options = { year: "numeric", month: "long", day: "numeric" } as const;
    const deadlineDateString = deadlineDate.toLocaleDateString(
      "en-US",
      options
    );

    // Immediately invoked function to extract the recipient's name from the email address
 
    const recipientName = email;
    // (() => {
    //   const [localPart] = email.split('@');
    //   const [firstName, lastName] = localPart.split('.');
    //   return `${firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase()} ${lastName.charAt(0).toUpperCase() + lastName.slice(1).toLowerCase()}`;
    // })();

    const emailPayload = {
      toEmail: email,
      subject:
        "Action Required: Take the Product IT Assessment Survey (Timeline 30 Days)",
      html: `<div style="font-family: Arial, sans-serif; line-height: 1.6;">
      <p>Dear ${recipientName},</p>
      <p>We are excited to invite you to participate in our <strong>Product IT Assessment Survey</strong>, designed to help you assess your organization’s current Product-IT landscape. Upon completion of the survey, our system will analyze your responses and provide personalized recommendations to help guide your organization’s next steps.</p>
      <p>To begin the survey, please click the link below:</p>
      <p style="text-align: center;">
        <a href="${process.env.REACT_APP_OTP_BASE_URL}${surveyId}" target="_blank" style="display: inline-block; padding: 10px 20px; font-size: 16px; color: #ffffff; background-color: #007bff; text-decoration: none; border-radius: 5px;">Start Survey</a>
      </p>
      <p>The survey will take approximately <strong>5 mins</strong> to complete. Once submitted, our system will process your answers and generate recommendations tailored to your specific needs.</p>
      <p><strong>Please note:</strong> the survey link will remain active for the next <strong>30 days</strong>, and your responses will be kept confidential.</p>
      <p><strong>Deadline for submission:</strong> ${deadlineDateString}.</p>
      <p>Should you have any questions or require assistance during the survey process, please feel free to reach out to us at [your contact information].</p>
      <p>We appreciate your participation and look forward to helping you identify the best path forward for your organization.</p>
      <p>Thank you for your time!</p>
      <p>Best regards,</p>
      <p>[Name]<br>[Job Title]<br>[Company]<br>[Contact Information]</p>
    </div>
      `,
    };
 
    try {
      const res = await postEmail(emailPayload); // Set OTP flag in session storage
      // sessionStorage.setItem("Otp_Flag", "true");
      return res.data;
    } catch (error) {
      console.error("Error sending email:", error);
      alert("Error sending email");
    }
  };
 
  const handleSubmit = async (event: any) => {
    event.preventDefault();
    const surveyName = event.currentTarget.elements[0] as HTMLInputElement;
    inputs["setId"] = setId;
    inputs["emails"] = emails;
    inputs["surveyName"] = surveyName.value;
    inputs["setName"] = setName;
    inputs["requestor"] = requestor;
 
    let havingAllFieldVals: boolean = false;
    if (Object.keys(inputs).length) {
      havingAllFieldVals = Object.keys(inputs).every((key) => inputs[key]);
    }
    if (!havingAllFieldVals || inputs["emails"].length === 0 || !showTable) {
      toast.error(
        "Please enter values in all input fields or check set name result."
      );
    } else {
      let payload = { inputs };
 
      postSurvey(payload.inputs)
        .then((data) => {
          setSurveyData(data.data);
          Promise.all(
            data.data.map((item: { surveyId: number; email: string }) =>
              sendEmail(item.surveyId, item.email)
            )
          );
        })
        .then(() => {
          navigate("/dashboard");
          toast.success("Survey created and email sent successfully!");
        })
        .catch((error) => {
          toast.error(error);
        });
    }
  };
 
  return (
    <div className="container">
      <Navbar />
      <form onSubmit={handleSubmit}>
        <div className="app-pageSize">
          {!data?.flag ? (
            <ActiveLink targetLink="Approval Panel" />
          ) : (
            <div className="target-link">
              <Link to="/dashboard">Dashboard</Link>
              <p style={{ fontSize: "10px" }}>&#10095;</p>
              <p> Survey </p>
            </div>
          )}
          {/* <div> */}
          <div style={{ boxShadow: "0.5px 0.5px 0px 0px grey" }}>
            <div
              className="my-page"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              {data?.flag ? (
                <h4 className="my-page">Survey ID : {AssessmentDetails.id}</h4>
              ) : (
                <h4 className="my-page">Survey Details </h4>
              )}
            </div>
            <div className="input-fields-container">
              <div className="container px-5 py-3">
                <div className="row mb-4">
                  <div className="row col-sm-6">
                    {/* <label htmlFor="domain" className="surveyLabel col-form-label col-sm-4">
                      Domain:
                    </label> */}
                    <label
                      htmlFor="surveyName"
                      className="surveyLabel col-form-label col-sm-4"
                    >
                      Survey Name:
                    </label>
                    <div className="col-sm-8">
                      {/* <TypeaheadDomain /> */}
                      <input
                        type="text"
                        className="surveyCreateInputs form-control"
                        id="surveyName"
                        name="surveyName"
                        placeholder={
                          !data?.flag
                            ? "Enter survey name"
                            : AssessmentDetails?.surveyName // Changed domain to surveyName
                        }
                        disabled={data?.flag}
                        // value={AssessmentDetails?.domain}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row col-sm-6">
                    <label
                      htmlFor="company"
                      className="surveyLabel col-form-label col-sm-4"
                    >
                      Company Name:
                    </label>
                    <div className="col-sm-8">
                      <input
                        className="surveyCreateInputs form-control"
                        type="text"
                        id="company"
                        name="company"
                        placeholder={
                          !data?.flag
                            ? "Enter company name"
                            : AssessmentDetails?.companyName
                        }
                        disabled={data?.flag}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  {/* using react Multiemail */}
                  <div className="row col-sm-6">
                    <label
                      htmlFor="description"
                      className="surveyLabel col-sm-4"
                    >
                      Description:
                    </label>
                    <div className="col-sm-8">
                      <textarea
                        ref={descriptionRef}
                        className="surveyCreateInputs form-control"
                        id="description"
                        name="surveyDscr"
                        placeholder="Enter description"
                        disabled={data?.flag}
                        maxLength={250}
                        onChange={handleChange}
                      />
                      <span className="float-end">{descCount}/250</span>
                    </div>
                  </div>
 
                  <div className="row col-sm-6">
                    <label htmlFor="requestor" className="surveyLabel col-sm-4">
                      Requester:
                    </label>
                    <div className="col-sm-8">
                      <input
                        className="surveyCreateInputs form-control"
                        type="text"
                        id="requestor"
                        name="requestor"
                        placeholder="Enter requester"
                        value={requestor} // Added input field for requestor
                        onChange={(e) => setRequestor(e.target.value)} // Added onChange handler for requestor
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="email-field">
                <label htmlFor="email" className="surveyLabel">
                  Email Id:
                </label>
                <ReactMultiEmail
                  placeholder="Email Address"
                  emails={emails}
                  onChange={(_emails: string[]) => {
                    setEmails(_emails);
                  }}
                  getLabel={(
                    email: string,
                    index: number,
                    removeEmail: (index: number) => void
                  ) => {
                    return (
                      <div data-tag key={index}>
                        <div data-tag-item>{email}</div>
                        <span
                          data-tag-handle
                          onClick={() => removeEmail(index)}
                        >
                          ×
                        </span>
                      </div>
                    );
                  }}
                />
              </div>
            </div>
          </div>
          <br />
          <div style={{ boxShadow: "0px 0.5px 0.5px 0px grey" }}>
            {!data && (
              <div className="nameDiv">
                <div className="nameChild">
                  {/* <div className="nameInput">
                    <label className="col-sm-3">
                      Set Name:{" "}
                    </label>
                    {!location.state ? (
                      <><input
                        type="text"
                        name="setId"
                        placeholder="Set Name"
                        className="nameBox form-control"
                        onChange={handleChange}
                        onInput={handleSetNameChange} />
                        <button
                          type="button"
                          onClick={handleDisplay}>
                          Search
                        </button>
                      </>
                    ) : (
                      <h4 style={{ color: "white" }}>Set Name</h4>
                    )}
                  </div> */}
 
                  <div className="nameInput">
                    <label className="col-sm-3">Set Name:</label>
                    {!location.state ? (
                      <>
                        <Typeahead
                          id="assessment-search"
                          onChange={handleSetNameChange} // Updated to use Typeahead
                          options={sets}
                          labelKey="setName"
                          placeholder="Search Assessment"
                          selected={searchTerm ? [{ setName: searchTerm }] : []}
                        />
                        <button type="button" onClick={handleSearch}>
                          {" "}
                          Search{" "}
                        </button>
                      </>
                    ) : (
                      <h4 style={{ color: "white" }}>Set Name</h4>
                    )}
                  </div>
                </div>
              </div>
            )}
            {showTable && (
              // <div className="table-container">
              //   <table className="custom-table">
              //     <thead>
              //       <tr>
              //         <th className="surveyHeading">SRL No</th>
              //         <th className="surveyHeading">Question</th>
              //         {/* <th className="surveyHeading">
              //       Explore and Edit the options
              //     </th> */}
              //         <th className="surveyHeading"></th>
              //       </tr>
              //     </thead>
              //     <tbody>
              //       {tableData.map((row: any, index: number) => (
              //         <tr
              //           key={index}
              //           style={{ backgroundColor: getRowColor(index) }}
              //         >
              //           <td>{index + 1}</td>
              //           <td>{row.quesDscr}</td>
              //           {/* <td>
              //         <button className="clickButton">Click Here</button>
              //       </td> */}
              //           <td>
              //             {" "}
              //             {/* <img
              //             src={require("../../../images/delete.png")}
              //             alt=""
              //           /> */}
              //           </td>
              //         </tr>
              //       ))}
              //     </tbody>
              //   </table>
              // </div>
              <div className="table-container">
                <table className="custom-table">
                  <thead>
                    <tr>
                      <th className="surveyHeading">SRL No</th>
                      <th className="surveyHeading">Section Name</th>
                      <th className="surveyHeading">Question</th>
                    </tr>
                  </thead>
                  <tbody>
                  {(() => {
                      let serialNumber = 1; // Initialize a global counter
                      return tableData.map((section: any, sectionIndex: number) =>
                      section.questionList.map(
                        (question: any, questionIndex: number) => (
                          <tr key={question.quesId}>
                            <td>{serialNumber++}</td>{" "}
                            {/* Continuous numbering */}
                            <td>{section.sectionName}</td>{" "}
                            {/* Section Name Column */}
                            <td>{question.quesDscr}</td>
                          </tr>
                        )
                      ))
                    })()}
                  </tbody>
                </table>
              </div>
            )}
            {data?.flag && (
              <div className="table-container">
                <table className="custom-table">
                  <thead>
                    <tr>
                      <th className="surveyHeading">S.No</th>
                      <th className="align-heading">Question</th>
                      {["Completed".toLowerCase()].includes(
                        AssessmentDetails?.status
                      ) && <th className="align-heading">Answer</th>}
                      {/* <th className="surveyHeading">
                    Explore and Edit the options
                  </th> */}
                      {/* <th className="surveyHeading">Delete</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.map((row: any, index: number) => (
                      <>
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{row.quesDscr}</td>
                          <td>
                            <select className="survey-answer" disabled={true}>
                              {row.options.map((opt: any, indx: number) => (
                                <option value={opt.optionId}>
                                  {opt.suggestion}
                                </option>
                              ))}
                            </select>
                          </td>
 
                          {/* <td>
                      <button className="clickButton">Click Here</button>
                    </td> */}
                          {/* <td>
                        {" "}
                        <img
                          src={require("../../../images/delete.png")}
                          alt=""
                        />
                      </td> */}
                        </tr>
                        {["Completed".toLowerCase()].includes(
                          AssessmentDetails?.status
                        ) && (
                          <tr>
                            <td colSpan={3}>
                              <strong>Suggestion: </strong>
                              {row.options[0].suggestion}
                            </td>
                          </tr>
                        )}
                      </>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
          {data?.flag ? (
            <div className="submit-div">
              <button
                type="button"
                className="submit-btn"
                onClick={() => {
                  navigate("/dashboard");
                }}
              >
                Close
              </button>
            </div>
          ) : (
            <div className="submit-div">
              <button
                type="submit"
                className="submit-btn"
                // onClick={() => {
                //   navigate("/dashboard");
                // }}
              >
                Submit
              </button>
            </div>
          )}
          {/* </div> */}
        </div>
      </form>
    </div>
  );
};
 
export default SurveyCreation;
 